/**
 * dep.ts — Categoría "Deportes" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_dep",
  skuPrefix: "DEP",
  categoria: "Deportes",
} as const;

export const cat_dep_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Mancuernas 5kg Par",
    marca: "Bodytech",
    modelo: "Hex 5kg",
    origen: "China",
    costo: 85000,
    precio: 129000,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "par",
    ubicacionFisica: "Estante D1",
    proveedor: "Bodytech Colombia",
    material: "Hierro vulcanizado",
    descripcionLarga:
      "Par mancuernas hexagonales 5kg cada una. Goma antideslizante, mango cromado. Ideal entrenamiento casa.",
    especificaciones: [
      { clave: "Peso c/u", valor: "5kg" },
      { clave: "Forma", valor: "Hexagonal" },
    ],
    imageKeywords: ["dumbbells", "weights", "home-gym"],
    color: "bg-slate-900",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Colchoneta Yoga 6mm",
    marca: "Manduka",
    modelo: "PRO Yoga Mat",
    origen: "Alemania",
    costo: 185000,
    precio: 289000,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "unidad",
    ubicacionFisica: "Estante D2",
    proveedor: "Manduka Colombia",
    garantia: "Vitalicia",
    material: "PVC denso",
    colorProducto: "Púrpura",
    dimensiones: "180x66x6mm",
    descripcionLarga:
      "Colchoneta yoga premium 6mm, densidad cerrada anti-microbiana. Durabilidad extrema, no se desgasta.",
    especificaciones: [
      { clave: "Grosor", valor: "6mm" },
      { clave: "Tamaño", valor: "180x66cm" },
    ],
    imageKeywords: ["yoga-mat", "exercise-mat", "manduka"],
    color: "bg-purple-500",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Bicicleta Spinning",
    marca: "Peloton",
    modelo: "Bike Basic",
    origen: "Taiwán",
    costo: 2850000,
    precio: 4390000,
    stock: 5,
    stockMinimo: 2,
    stockMaximo: 10,
    unidad: "unidad",
    ubicacionFisica: "Showroom D3",
    proveedor: "Peloton Colombia",
    garantia: "1 año",
    material: "Acero y plástico",
    descripcionLarga:
      "Bicicleta indoor spinning volante inercial 18kg, resistencia magnética 32 niveles. Monitor LCD.",
    especificaciones: [
      { clave: "Volante", valor: "18kg" },
      { clave: "Resistencia", valor: "Magnética 32 niveles" },
    ],
    imageKeywords: ["spinning-bike", "exercise-bike", "indoor-bike"],
    color: "bg-slate-900",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Cuerda de Saltar",
    marca: "Rogue",
    modelo: "SR-1 Speed Rope",
    origen: "EE.UU.",
    costo: 45000,
    precio: 69900,
    stock: 50,
    stockMinimo: 12,
    stockMaximo: 100,
    unidad: "unidad",
    ubicacionFisica: "Estante D1",
    proveedor: "Rogue Fitness Colombia",
    material: "Cable acero + aluminio",
    descripcionLarga:
      "Cuerda speed rope cable acero 2.5mm con mangos aluminio girables 360°. Ajustable, ideal crossfit.",
    especificaciones: [
      { clave: "Cable", valor: "2.5mm acero" },
      { clave: "Longitud", valor: "Ajustable hasta 3m" },
    ],
    imageKeywords: ["jump-rope", "speed-rope", "crossfit"],
    color: "bg-slate-900",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Bandas Resistencia Set",
    marca: "TheraBand",
    origen: "EE.UU.",
    costo: 55000,
    precio: 84900,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "set",
    ubicacionFisica: "Estante D1",
    proveedor: "TheraBand Colombia",
    material: "Látex",
    descripcionLarga:
      "Set 5 bandas elásticas niveles resistencia diferentes. Incluye 2 manijas, 2 anclas, bolso transporte.",
    especificaciones: [
      { clave: "Bandas", valor: "5 niveles" },
      { clave: "Accesorios", valor: "Manijas + anclas" },
    ],
    imageKeywords: ["resistance-bands", "exercise-bands", "fitness-bands"],
    color: "bg-red-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Raqueta Tenis Wilson",
    marca: "Wilson",
    modelo: "Pro Staff 97",
    origen: "China",
    costo: 485000,
    precio: 749000,
    stock: 10,
    stockMinimo: 3,
    stockMaximo: 20,
    unidad: "unidad",
    ubicacionFisica: "Vitrina D4",
    proveedor: "Wilson Colombia",
    garantia: "6 meses",
    material: "Grafito",
    descripcionLarga:
      "Raqueta Pro Staff 97 grafito con tecnología BLX. Peso 315g, cabeza 97in². Incluye funda.",
    especificaciones: [
      { clave: "Peso", valor: "315g" },
      { clave: "Cabeza", valor: "97in²" },
    ],
    imageKeywords: ["tennis-racket", "wilson-racket", "tennis-gear"],
    color: "bg-slate-900",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Pelota Básquetbol Oficial",
    marca: "Spalding",
    modelo: "NBA Official",
    origen: "China",
    costo: 125000,
    precio: 189000,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "unidad",
    ubicacionFisica: "Estante D5",
    proveedor: "Spalding Colombia",
    material: "Cuero compuesto",
    colorProducto: "Naranja",
    descripcionLarga:
      'Pelota Spalding oficial NBA talla 7 (29.5"), cuero compuesto. Apta indoor/outdoor. Profesional.',
    especificaciones: [
      { clave: "Talla", valor: "7" },
      { clave: "Uso", valor: "Indoor/Outdoor" },
    ],
    imageKeywords: ["basketball", "spalding", "sports-ball"],
    color: "bg-orange-500",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Proteína Whey 2lb",
    marca: "Optimum Nutrition",
    modelo: "Gold Standard",
    origen: "EE.UU.",
    costo: 185000,
    precio: 289000,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "tarro",
    ubicacionFisica: "Estante D6",
    pesoNeto: "907g",
    proveedor: "Glanbia Nutritionals",
    vencimientoMeses: 18,
    descripcionLarga:
      "Proteína whey aislada Gold Standard 2lb, 24g proteína/scoop, sabor vainilla. 29 porciones.",
    especificaciones: [
      { clave: "Porciones", valor: "29" },
      { clave: "Proteína", valor: "24g/scoop" },
    ],
    imageKeywords: ["whey-protein", "optimum-nutrition", "supplement"],
    color: "bg-amber-500",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Guantes Boxeo 14oz",
    marca: "Everlast",
    modelo: "Pro Style",
    origen: "China",
    costo: 125000,
    precio: 189000,
    stock: 18,
    stockMinimo: 5,
    stockMaximo: 36,
    unidad: "par",
    ubicacionFisica: "Estante D5",
    proveedor: "Everlast Colombia",
    material: "Cuero sintético",
    colorProducto: "Negro/rojo",
    descripcionLarga:
      "Guantes boxeo 14oz entrenamiento con relleno de espuma. Cierre velcro, costura reforzada.",
    especificaciones: [
      { clave: "Peso", valor: "14oz" },
      { clave: "Cierre", valor: "Velcro" },
    ],
    imageKeywords: ["boxing-gloves", "everlast", "training-gloves"],
    color: "bg-slate-900",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Botella Deportiva Inox 1L",
    marca: "Hydro Flask",
    origen: "EE.UU.",
    costo: 95000,
    precio: 149000,
    stock: 40,
    stockMinimo: 10,
    stockMaximo: 80,
    unidad: "unidad",
    ubicacionFisica: "Góndola D7",
    proveedor: "Hydro Flask Colombia",
    garantia: "Vitalicia",
    material: "Acero inoxidable 18/8",
    colorProducto: "Negro mate",
    descripcionLarga:
      "Botella térmica Hydro Flask 1L, doble pared acero 18/8. Mantiene frío 24h, caliente 12h.",
    especificaciones: [
      { clave: "Volumen", valor: "1L" },
      { clave: "Frío", valor: "24h" },
    ],
    imageKeywords: ["water-bottle", "hydro-flask", "sport-bottle"],
    color: "bg-slate-900",
    shape: "circle",
  }),
];
